/* eslint-disable no-irregular-whitespace */
/**
 * 全局api变量
 * 一定要加上注释
 */

// 通用
export const SMS_SEND = 'wechat/user/sms_send' // 发送短信验证码
export const SMS_LOGIN = 'wechat/user/sms_login' // 短信登录
export const UPDATE_LOGIN = 'wechat/user/update' // 用户信息更新
export const WECHAT_LOGIN = 'wechat/user/wechat_login' // 微信授权登陆
export const DETAIL_GET = 'https://open.myqj365.com/artme/wxArticle/xcx/' // 详情外链

// 课程
export const COURSE_DETAIL = 'wechat/course/details' // 课程详情
export const COURSE_LIST = 'wechat/course/list' // 课程列表
export const SUB_COURSE_LIST = 'wx_bwg/lookCourse/querySubCourseList' // 课程列表1
export const SUB_COURSE = 'wechat/course/sub_course' // 子课程详情
export const BUY_BROWSE = 'wx_bwg/distributionData/statisticsDistributionVisits' // 检查record_id
// export const BUY_BROWSE = 'wechat/order/buy_browse' // 检查record_id
export const VIEW = 'wechat/course/view' // 观看视频
export const GET_VIDEO = 'wechat/course/get_video' // 获取视频
export const GET_OUTCONTENT = 'wechat/course/get_outContent' // 获取外链文本
export const POST_VIDEOTIME = 'wx_bwg/play/record/up' // 提交视频已观看时间
export const RECORD_LOG = 'wx_bwg/play/record/log' // 提交视频已观看时间
export const INTRODUCE = 'wx_bwg/course/introduce'// 详情长图


// 评论
export const LIST = 'wx_bwg/comment/list' // 获取评论列表
// export const LIST = 'wechat/comment/list' // 获取评论列表
export const LIKE = 'wechat/comment/like' // 点赞评论
export const DISLIKE = 'wechat/comment/dislike' // 取消点赞评论
export const CREATE = 'wechat/comment/create' // 发表评论

// export const ORDER_LIST = 'wechat/order/order_list' // 订单列表
export const ORDER_LIST = 'wechat/order/list' // 订单列表
export const ORDER_INFO = 'wechat/order/get_order_info' // 订单详情
// 支付
export const ORDER_CHECK = 'wx_pay/pay/checkOrder' // 检查订单
export const INVITE_GROUP = 'wx_pay/order/invite_group' // 检查团购参团状态
export const CREATE_SINGLE_ORDER = 'wx_pay/pay/wxpay' // 创建单人购订单
export const CREATE_GROUP_ORDER = 'wx_pay/pay/wxpay' // 创建团购订单
// 测试支付
// export const ORDER_CHECK = 'http://test.pay.artme.net.cn/wx_pay/pay/checkOrder' // 检查订单
// export const INVITE_GROUP = 'http://test.pay.artme.net.cn/wx_pay/order/invite_group' // 检查团购参团状态
// export const CREATE_SINGLE_ORDER = 'http://test.pay.artme.net.cn/wx_pay/pay/wxpay' // 创建单人购订单
// export const CREATE_GROUP_ORDER = 'http://test.pay.artme.net.cn/wx_pay/pay/wxpay' // 创建团购订单

export const INFO_ADDRESS = 'wx_bwg/addr/info'// id查地址
export const ADDR_CHOICE = 'wx_bwg/addr/choice'// 选择地址，查询运费
export const QUERY_ORDER_GROUP_BY_GID = 'wx_bwg/order/index/queryOrderGroupByGid' // 支付成功信息
export const GET_ORDER_PATH = 'wx_bwg//sf/index/getOrderPath' // 物流信息
export const IS_VERIFICATION = 'wx_bwg/order/index/isVerificationOrder' // 判断订单是否是实物，是否开启IOS
export const QUERY_ORDER_ADDRESS = 'wx_bwg//order/index/queryOrderAddress' // 查询用户历史地址
export const QUERY_COURSE_TRY_TO_SEE = 'wx_bwg/course/queryCourseTryToSee'// 订单详情，课程详情
export const CHECK_FOLLOW = 'http://mgz.artme.net.cn/wx_bwg/follow/checkFollow'// 检查用户是否关注公众号
export const CHECK_FOLLOWS = 'http://mgz.artme.net.cn/wx_bwg/follow/check'// 检查用户是否关注公众号

// END
export const BEFORE_RECEIVE_CHECK = 'wechat/order/before_receive_check' // 领取前检查
// export const WECHAT_CONFIG = 'https://wx.pay.artme.net.cn/wx_pay/pay/shareWeiXin' // 微信js-sdk配置
export const WECHAT_CONFIG = 'wx_bwg/wxSdk/get_weixin_signature' // 微信js-sdk配置
// export const WECHAT_CONFIG = 'wechat/order/get_weixin_signature' // 微信js-sdk配置
export const SHARE = 'wechat/order/share' // 分享
export const SHARE_SUCCESS = 'wechat/order/share_success' // 赠送成功
export const ORDER_RECIEVE = 'wechat/order/receive' // 创建领取订单
export const ORDER_RECIEVE_CHECK = 'wechat/order/receive_check' // 检查课程领取订单

// 个人模块
export const GET_APPELL_LIST_URL = 'wechat/personal/appellLists' // 获取我的勋章
export const GET_COURSE_LIST_URL = 'wechat/personal/courselist' // 获取我的课程
export const GET_SHARE_IMG_URL = 'wechat/system/lists' // 获取分享配图

// export const GET_MY_WALLET = 'wx_bwg/my/queyrMyWallet'// 获取我的钱包
export const GET_MY_WALLET = 'wx_bwg/my/queyrMyWallet'// 获取我的钱包


// 假日出发
export const ACTIVITY_LIST = 'wechat/activity/list' // 获取假日出发活动列表
export const ACTIVITY_DETAILS = 'wechat/activity/details' // 获取假日出发活动详情

// 抽奖模块
export const ANSWERLIST = 'wechat/answer/lists' // 获取题目详情
export const SUBMITANSWER = 'wx_bwg/quiz/addAnswerRecord' // 获取题目详情
export const QUESTION_RECORD = 'wx_bwg/quiz/queryMedalByRId' // 分享称号信息

// 新增课程助力
export const CREATE_ASSISTANCE = 'wechat/assistance/initiate' // 发起助力
export const POST_ASSISTANCE_ID = 'wechat/assistance/assist' // 助力POST
export const ASSISTANCE_ID_LIST = 'wechat/assistance/list' // 助力ID列表
export const ASSISTANCE_POSTER = 'wechat/assistance/get_share_poster' // 助力海报

// 新增用户分享
export const SHARE_BILL = 'wx_bwg/my/sharingPosters' // 获取分享海报
export const SHARE_BILL_PRICE = 'wx_bwg/my/queryCourseSharingPrice' // 分享按钮曝光次数

// 新增获取用户信息
export const WECHAT_INFO = 'wechat/user/wechat_info'

// 新增获取分享文案
export const SHARE_CONTENT = 'wechat/course/get_share_contents' // 获取微信分享文案

// 获取优惠券列表
// export const GET_COUPON_LIST = 'wechat/coupon/list' // 获取用户优惠券列表
export const GET_COUPON_LIST = 'wx_bwg/whController/queryCoupon' // 获取用户优惠券列表

export const JAVA_IS_ATTEND = 'bwg/curriculum/queryRecommend' // 获取课程详情

// 我的提现历史
export const MY_APPLY_HISTORY = 'wx_bwg/my/queryPresentingHistory'

export const ADD_APPLY_HISTORY = 'wx_bwg/my/addApplyCashWithdrawal'

export const JAVA_GET_IMG = 'wx_bwg/user/getImgVerify' // 获取验证码图片
export const JAVA_GET_LENGHT = 'wx_bwg/user/verifyImageCode' // 提交验证滑动距离
export const JAVA_GET_CODE = 'wx_bwg/user/getVerificationCode' // 获取验证码
export const JAVA_SEND_CODE = 'wx_bwg/user/login' // 提交验证码
export const JAVA_GET_PHONE = 'wx_bwg/user/queryUserPhoneIsTrue' // 获取手机号

export const JAVA_PLACE_ZDM = 'wx_bwg/cooperation/addCooperativeUserAccessRecord' // 提交值得买log


// 直播
export const DIRECT_BROADCAST_LIST = 'wx_bwg/live/list'
export const JOIN_CHAT_ROOM = 'wx_bwg/im/joinchatroom' // 加入聊天室
export const FOR_BID_SEND_MSG = 'wx_bwg/im/forbidSendMsg' // 禁言用户
export const GET_USER_SIG = 'wx_bwg/im/getUserSig' // 获取用户签名
export const SELECT_ADMIN_ISTRATOR = 'wx_bwg/im/selectAdministrator' // 查询角色身份
export const SETUP_ADMIN_ISTRATOR = 'wx_bwg/im/setupAdministrator' // 设置取消管理员
export const SELECT_USER_SILENCE = 'wx_bwg/im/selectUserSilencedStatus' // 查询当前用户禁言信息
export const SUBSCRIPTION_QUERY = 'wx_bwg/subscription/query' // 查询当前用户是否订阅
export const SUBSCRIPTION_INSERT = 'wx_bwg/subscription/insert' // 添加订阅
export const QUERY_CHAT_NUM = 'wx_bwg/im/queryChatRoomMun' // 直播观看人数

// 关于物流
export const ALL_ADDRESS = 'wx_bwg/addr/list'// 所有地址
export const ADD_ADDRESS = 'wx_bwg/addr/add'// 添加地址
export const UPDATE_ADDRESS = 'wx_bwg/addr/update'// 修改地址
export const DEL_ADDRESS = 'wx_bwg/addr/del'// 删除地址

// 导览博物馆
export const QUERY_MUSEUM_INFO = 'wx_bwg/museum/queryMuseumInfo'// 博物馆列表
export const QUERY_MUSEUM_DETAILS = 'wx_bwg/museum/queryMuseumDetails' // 博物馆详情
export const PUBLISH_STATE = 'wx_bwg/course/publishState'// 视频课程显示隐藏
export const QUERY_USER_MUSEUM = 'wx_bwg/museum/queryUserMuseumRecord' // 我的导览
// 导览
export const QUERY_SHOW_ROOM = 'wx_bwg/museum/queryShowRoomDetails' // 导览详情
export const SAVE_USER_GUIDE = 'wx_bwg/museum/saveUserGuideRecord' // 添加用户记录
export const QUERY_EXHIBITS = 'wx_bwg/museum/queryExhibitsAll' // 播放列表



// WEBPACK FOOTER //
// ./src/api/global.js